import React from 'react';

interface SearchFormProps {
    updateOrderBy: (e: React.ChangeEvent<HTMLInputElement>) => void;
    orderBy: string;
    uniqueId: string;
}

export const SearchOrderBy: React.FC<SearchFormProps> = ({ updateOrderBy, orderBy, uniqueId }) => {
    return (
        <div className="spaced-list">
            <div>
                <input type="radio" className="radio-btn" checked={orderBy === 'datedesc'} id={`sortByDesc_${uniqueId}`} name={`sortBy_${uniqueId}`} value="datedesc" onChange={(e) => {
                    updateOrderBy(e as React.ChangeEvent<HTMLInputElement>);
                }} />
                <label htmlFor={`sortByDesc_${uniqueId}`}>Date (newest)</label>
            </div>
            <div>
                <input type="radio" className="radio-btn" checked={orderBy === 'dateasc'} id={`sortByAsc_${uniqueId}`} name={`sortBy_${uniqueId}`} value="dateasc"
                    onChange={(e) => {
                        updateOrderBy(e as React.ChangeEvent<HTMLInputElement>);
                    }}
                />
                <label htmlFor={`sortByAsc_${uniqueId}`}>Date (oldest)</label>
            </div>
            <div>
                <input type="radio" className="radio-btn" checked={orderBy === 'a-z'} id={`sortAlpha_${uniqueId}`} name={`sortBy_${uniqueId}`} value="a-z" onChange={(e) => {
                    updateOrderBy(e as React.ChangeEvent<HTMLInputElement>);
                }} />
                <label htmlFor={`sortAlpha_${uniqueId}`}>A-Z</label>
            </div>
            <div>
                <input type="radio" className="radio-btn" checked={orderBy === 'z-a'} id={`sortAlphaReversed_${uniqueId}`} name={`sortBy_${uniqueId}`} value="z-a"
                    onChange={(e) => {
                        updateOrderBy(e as React.ChangeEvent<HTMLInputElement>);
                    }}
                />
                <label htmlFor={`sortAlphaReversed_${uniqueId}`}>Z-A</label>
            </div>
        </div>
    )
}